/**
 * @description 核心功能方法
 * @summary step 1: 执行proxyApi 附加getter/setter 生成 this.attrs 属性--对象需要原型链方法 this.update(fn)
 * @summary step 2: 执行proxyEvent 附加事件钩子--个性化事件过程的方法,可以定义在对象原型链中
 * @summary step 3: 执行compileSymbol 模板生成中,将模板关键节点提取至 this.members 属性中
 * @summary step 4: 执行update 激活 this.update(fn) 绑定回调,并执行 updater 更新视图
 * @summary step 5: 执行updater 更新视图 提取 this.attrs 对应名称 并执行方法集中的同名方法
 */
const core = {
  /**
   * @description 将对象中 defaults 的属性,变成对象的 setter/getter 属性,存入 attrs中
   * @param {*} tar packages对象
   */
  proxyApi(tar) {
    const arr = Object.keys(tar.defaults)
    arr.forEach((key) => {
      Object.defineProperty(tar, key, {
        get: () => {
          return tar.settings[key]
        },
        set: (flag) => {
          tar.settings[key] = flag
          tar._update(tar.settings)
        }
      })
    })
    tar.attrs = arr
    tar.old = {}
  },
  /**
   * @description 将对象中 events 的属性,变成对象的 事件回调方法
   * @param {*} tar packages对象
   */
  proxyEvent (tar) {
    if (!tar.events) return
    Object.entries(tar.events).map(([key, value]) => {
      tar[key] = (res) => {
        if (res && $.type(res) === 'function') {
          tar[`_${key}`] = res
        } else {
          let trick // 是否继续执行下去的标记,通过回调方法给予
          value && $.type(tar[value]) === 'function' && (trick = tar[value](res))
          if (trick === false) return
          $.type(tar[`_${key}`]) === 'function' && tar[`_${key}`](tar, trick)
        }
      }
    })
  },
  /**
   * @description 将对象中 events 的属性,变成对象的 事件回调方法
   * @param {*} fn 回调方法对象集(储存若干方法的对象)
   * @param {*} opt 原对象配置
   * @param {*} tar packages对象
   * @param {*} node 直接操作的dom节点
   */
  update(fn, opt, tar, node) {
    tar.update(opt => {
      this.updater(fn, opt, tar, node)
    })
    this.updater(fn, opt, tar, node)
  },
  /**
   * @description 更新器 执行 attrs 的属性对应名称的方法
   * @param {*} fn 回调方法对象集(储存若干方法的对象)
   * @param {*} opt 原对象配置
   * @param {*} tar packages对象
   * @param {*} node 直接操作的dom节点
   */
  updater(fn, opt, tar, node) {
    const attrs = tar.attrs
    const old = tar.old
    attrs.map((key) => {
      if (opt[key] !== old[key]) {
        old[key] = opt[key]
        $.isFunction(fn[key]) && fn[key](opt[key], opt, tar, node)
      }
    })
  },
  /**
   * @description 将模板字符串 有id 标识的dom节点 提取储存在一个objs对象中
   * @param {*} template 模板字符串
   * @param {*} obj 储存对象 { id:dom }
   */
  compileSymbol(template, obj) {
    Array.from(template.childNodes).forEach(node => {
      if (node.nodeType === 1) {
        if (node.id) {
          obj[node.id] = $(node)
          node.removeAttribute('id')
        }
      }
      if (node.childNodes) {
        this.compileSymbol(node, obj)
      }
    })
  },

  currySomething(fn) {
    return (objs) => {
      return (res) => {
        let items
        if (res && res.length) {
          const news = {}
          Object.entries(objs).map((item) => {
            if (res.includes(item[0])) {
              news[item[0]] = item[1]
            }
          })
          items = news
        } else {
          items = objs
        }
        for (const name in items) {
          fn(items, name)
        }
      }
    }
  }
}
export default core
